export default __webpack_public_path__ + "static/header_image_two-fb246bd06f24f3876e51eed481ff1ec6.jpg";